import { similar_text } from '../../../../utils/helper/helper_wordtask';
export class DisproveSimilarText {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get comparer() {
        return this.parent;
    }
    get allSolutionSubstringsWithInputLength() {
        const subs = [];
        for (let i = 0; i < this.comparer.cleanedExpectedInput.length; i++) {
            const sub = this.comparer.cleanedExpectedInput.substr(i, this.comparer.userInput.length);
            if (sub.length === this.comparer.userInput.length) {
                subs.push(sub);
            }
        }
        return subs;
    }
    get disproveCertainty() {
        if (this.comparer.userInput.length === 0)
            return 0;
        let bestSimilar = 0;
        for (const sub of this.allSolutionSubstringsWithInputLength) {
            const now = similar_text(this.comparer.userInput, sub);
            if (now > bestSimilar)
                bestSimilar = now;
        }
        return 100 - bestSimilar;
    }
}
